import {
  IGetPopularCitiesForGeopopupResponse200,
  TGetPopularCitiesForGeopopupResponse,
} from '../../../repositories/geo-suggest/v1/get-popular-cities-for-geopopup';
import { ResponseError } from '../../../utils/errors';

export function assertResponseError(
  response: TGetPopularCitiesForGeopopupResponse,
): asserts response is IGetPopularCitiesForGeopopupResponse200 {
  if (response.statusCode === 200) {
    return;
  }

  const { message, errors } = response.response;

  throw new ResponseError({
    domain: 'shared/services/popularRegions/getPopularRegions#assertResponseError()',
    message: 'Failed loading popular regions',
    details: { message, errors },
  });
}
